<template>
  <div class="stanceBlock">
    <qua-form @handleSubmit="handleSubmit" :btnLoading="loading" btnText="立即认证"/>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { queryParams } from '../../../lib/utils'
import { submitBizLicense, updateBizlicenseInfo } from '@api/resourceApi'
import QuaForm from '../QuaForm'

const query = queryParams()

export default {
  name: 'QualityAuthLicense',
  data() {
    return {
      sourceCode: query.sourceCode || this.$route.query.sourceCode,
      isUpdate: query.isupdate || this.$route.query.isupdate,
      loading: false
    }
  },
  components: {
    QuaForm
  },
  methods: {
    // async getDetial() {
    //   console.log('getDetial-before');
    //   const { permitStatus, hasLicense } = await getbizlicense() //0未处理1成功2失败
    //   console.log('getDetial', permitStatus);
    //   if (+permitStatus === 0) return this.toDeal(); //提交成功
    //   if (+permitStatus === 1) return this.toSuccess(); //审核成功
    //   if (+permitStatus === 2 && +hasLicense === 1) return this.toPermit(); //经营许可
    //   return '' //营业执照
    // },
    handleSubmit(params) {
      console.log('handleSubmit', params);
      if (this.loading) return;
      const newParams = { ...params, sourceCode: this.sourceCode }
      this.loading = true;
      if (this.isUpdate == '1') {
        updateBizlicenseInfo(newParams)
          .then((_res) => {
            this.loading = false
            this.toSuccess();
          })
          .catch(() => {
            this.loading = false
          })
      } else {
        submitBizLicense(newParams)
          .then((_res) => {
            this.loading = false
            this.toSuccess();
          })
          .catch((err) => {
            this.loading = false
            console.error(err)
          })
      }
    },
    toSuccess() {
      console.log('toSuccess')
      setTimeout(() => {
        console.log('toSuccessRouter')
        native.skipToUrl({
          targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/qualityauth/success?sourceCode=${this.sourceCode}`,
          needClose: '1'
        })
      }, 300)
    }
  },
  mounted() {
    console.log('mounted');
    native.setTitle({
      title: '资质认证'
    })
    console.log('setTitle');
    // this.getDetial()
  }
}
</script>

<style lang="less">
  @import 'index.less';
</style>
